import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const UserEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        username: '',
        email: '',
        password: '',
        role: 'USER' // mặc định
    });
    const baseUrl = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("jwtToken");
            try {
                const res = await fetch(`${baseUrl}/users/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!res.ok) throw new Error('Không thể tải thông tin người dùng');

                const data = await res.json();
                setFormData({
                    name: data.name || '',
                    username: data.username || '',
                    email: data.email || '',
                    password: data.password || '', 
                    role: data.role || 'USER'
                });
            } catch (err) {
                console.error(err);
                setError(err.message || 'Lỗi khi tải thông tin người dùng');
            }
        };

        fetchUser();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem("jwtToken");

            const res = await fetch(`${baseUrl}/users/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData.message || 'Cập nhật thất bại');
            }

            Swal.fire({
                icon: 'success',
                title: 'Thành công',
                text: 'Cập nhật người dùng thành công!',
            }).then(() => {
                navigate('/admin');
            });

        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Lỗi',
                text: err.message || 'Có lỗi khi cập nhật',
            });
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-dashboard">
            <div className="back-button-container">
                <Link to="/admin" className="back-button">&larr; Quay về trang quản trị</Link>
            </div>

            <div className="form-container">
                <h2>Chỉnh sửa người dùng</h2>
                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Họ và tên</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="form-group">
                        <label>Tên đăng nhập</label>
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            disabled
                            maxLength={50}
                        />
                    </div>

                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            disabled
                            maxLength={50}
                        />
                    </div>

                    <div className="form-group">
                        <label>Mật khẩu mới</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Vai trò</label>
                        <select name="role" value={formData.role} onChange={handleChange} required>
                            <option value="ADMIN">ADMIN</option>
                            <option value="EMPLOYEE">EMPLOYEE</option>
                            <option value="MANAGER">MANAGER</option>
                        </select>
                    </div>

                    <div className="form-actions">
                        <button type="submit" className="submit-btn" disabled={loading}>
                            {loading ? 'Đang cập nhật...' : 'Cập nhật'}
                        </button>
                        <button type="button" className="cancel-btn" onClick={() => navigate('/admin')} disabled={loading}>
                            Hủy
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserEdit;
